import { NotificationCountResponse, NotificationRequestParams, NotificationResponse } from './types';

import { URL } from 'app/api/constants';
import { ServiceConfig } from 'app/api/utils/create-http-api-service';
import { defaultRequestService } from 'app/api/utils/default-request-service';

export const getAllNotifications = (
  config: ServiceConfig,
  requestData: NotificationRequestParams,
) => {
  type AdapterProps = { request: NotificationRequestParams; response: NotificationResponse };

  return defaultRequestService<AdapterProps>(URL.NOTIFICATIONS, config.instance.post, {
    requestData,
  });
};

export const getUnreadNotifications = (
  config: ServiceConfig,
  requestData: NotificationRequestParams,
) => {
  type AdapterProps = { request: NotificationRequestParams; response: NotificationResponse };

  return defaultRequestService<AdapterProps>(URL.NOTIFICATIONS_UNREAD, config.instance.post, {
    requestData,
  });
};

export const getUnreadNotificationsCount = (
  config: ServiceConfig,
) => {
  type AdapterProps = { response: NotificationCountResponse };

  return defaultRequestService<AdapterProps>(URL.NOTIFICATIONS_UNREAD_COUNT, config.instance.get);
};


export const markReadAllNotifications = (
  config: ServiceConfig,
) => {
  type AdapterProps = { response: NotificationCountResponse };

  return defaultRequestService<AdapterProps>(URL.NOTIFICATIONS_MARK_READ_ALL, config.instance.post);
};
